module.exports = __webpack_public_path__ + "images/category_lp/tablet/assessment_achievements/4_d2b9797f9a9767109958b210ad4edfba.jpg";